import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "CursoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "CursoPage",
            ss: ss,
            ajax: {
                "url": ss.indexCurso(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Curso', name: 'Curso', title: 'Curso' },
                { data: 'NivelAcademico', name: 'NivelAcademico', title: 'Nivel Academico' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripcion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            //para el segundo datatable
            columnsDetalle:[
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'PagoTesoreria', name: 'PagoTesoreria', title: 'Pago Tesoreria' },
                { data: 'Monto', name: 'Monto', title: 'Monto' },
                { data: 'FechaVencimiento', name: 'FechaVencimiento', title: 'Fecha de vencimiento' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            ajaxDetalle: {
                "url": ss.indexPagoTesoreriaCurso(),
                headers: ss.getToken(),
                data: function (d) {
                    d.Curso = 1;
                }
            },
            // fin de para el segundo data
            cursos: [],
            curso: {},
            nivelesacademicos: [],
            pagotesorerias: [],
            pagotesoreria: {},
            unidadesacademicas: {},
            pagotesoreriacurso : {},
            periodosacademicos: [],
            
            filtrosPagoTesoreria:{},
            isLoading: false,
            errorBag: {},
            ejecucion: {},
            search: null,
        };
    },
    methods: {
        //////////get unidad academica ////////////////////
        getPagosTesoreria() {
            this.ss.listPagoTesoreria2(this.filtrosPagoTesoreria).then(
                (result) => {
                    let response = result.data;
                    this.pagotesorerias = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        //////////get unidad academica ////////////////////
        getUnidadAcademica() {
            this.ss.listUnidadAcademica().then(
                (result) => {
                    let response = result.data;
                    this.unidadesacademicas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        //////////get nivel academico ////////////////////
        getNivelAcademico() {
            this.ss.listNivelAcademico().then(
                (result) => {
                    let response = result.data;
                    this.nivelesacademicos = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        //////////get periodo academico ////////////////////
        getPeriodoAcademico() {
            this.ss.listPeriodoAcademico().then(
                (result) => {
                    let response = result.data;
                    this.periodosacademicos = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newCurso() {
            this.curso = {};
            this.$refs['frm-curso'].show();
        },
        verPagoTesoreriaCurso() {
            this.$refs['view-pagotesoreriacurso'].show();
        },
        newPagoTesoreriaCurso() {
            this.pagotesoreriacurso = {};
            this.$refs['frm-pagotesoreriacurso'].show();
        },
        showPagoTesoreriaCurso(id){
            console.log("Ver Pago tesoreria curso");
            this.ss.showPagoTesoreriaCurso(id).then(
                (result) => {
                    let response = result.data;
                    this.pagotesoreriacurso = response.data;
                    //this.$refs['view-curso'].show();

                    this.$refs['view-pagotesoreriacurso'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editPagoTesoreriaCurso() {
            this.$refs['frm-pagotesoreriacurso'].show();
            this.$refs['view-pagotesoreriacurso'].hide();
        },
        savePagoTesoreriaCurso() {
            this.pagotesoreriacurso.Curso = this.curso.id;
            this.ss.storePagoTesoreriaCurso(this.pagotesoreriacurso).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-pagotesoreriacurso'].hide();
                    this.$refs['datatable-pagotesoreriacurso'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deletePagoTesoreriaCurso() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyPagoTesoreriaCurso(this.pagotesoreriacurso)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-pagotesoreriacurso'].hide();
                                this.$refs['datatable-pagotesoreriacurso'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        showCurso(id) {
            this.isLoading=true;
            this.ss.showCurso(id).then(
                (result) => {
                    let response = result.data;
                    this.curso = response.data;
                    //this.$refs['view-curso'].show();
                    this.ajaxDetalle.data = function(d){
                        d.Curso = id;
                    }
                    this.$refs['view-detalle-curso'].show();

                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editCurso() {
            this.$refs['frm-curso'].show();
            this.$refs['view-curso'].hide();
        },
        cancelCurso() {
            if (this.curso.id) {
                this.$refs['view-curso'].show();
            }
            this.$refs['frm-curso'].hide();
        },
        saveCurso() {
            this.ss.storeCurso(this.curso).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-curso'].hide();
                    this.$refs['datatable-curso'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteCurso() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyCurso(this.curso)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-curso'].hide();
                                this.$refs['datatable-curso'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },

        draw() {
            window.$('.btn-datatable-Curso').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showCurso(data);
            });
        },
        drawDetalle() {
            window.$('.btn-datatable-PagoTesoreriaCurso').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                // this.showCurso(data);
                console.log(data);
                this.showPagoTesoreriaCurso(data);
            });
        },
        select2PagoTesoreria(){
            this.isLoading = true;
            this.filtrosPagoTesoreria.q = this.search;
            this.ss.select2PagoTesoreria(this.filtrosPagoTesoreria).then((res) => {
                this.pagotesorerias = res.data.items;
                this.isLoading = false;
                return;
            })
        },
        elegirPagoTesoreria(){
            this.pagotesoreria = this.pagotesorerias.filter(e => {
                return e.id == this.pagotesoreriacurso.PagoTesoreria;
            })[0];
            if(this.pagotesoreria){
                this.pagotesoreriacurso.Monto = this.pagotesoreria.Monto;
            }
        },

    },
    watch: {
        search (val) {
            console.log(val);
            this.select2PagoTesoreria();
        },
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }else{
            this.getNivelAcademico();
            this.getUnidadAcademica();
            this.getPeriodoAcademico();
            this.select2PagoTesoreria();
        }
    }
};
